enum BiteLogPusherEvent {
  Ok = 0,
  Connected = 1,
  Subscribed = 2,
  Disconnected = 3,
  FailedToConnect = 4,
  FailedToSubscribe = 5,
  Error = 6,
  Initialized = 7,
}

export { BiteLogPusherEvent };
